// #356: the effort a row's deload rounds ask for, read back from its cells.
// Keep free of React and any UI import.
import { mode } from "./programMode.js";
import type { DeloadEffect, ReadSet } from "./programProgression.js";

/** A row with no value whose deload rounds are all on one effort axis (RPE or
 *  RIR): that axis and its most frequent value. Anything else: absent. */
export const recognizeDeloadEffort = (
  deloadSets: readonly ReadSet[],
  valueless: boolean,
): DeloadEffect["effort"] | undefined => {
  const axis = deloadSets[0]?.kind;
  if (!valueless || (axis !== "rpe" && axis !== "rir") || !deloadSets.every((s) => s.kind === axis)) return undefined;
  const value = mode(deloadSets.flatMap((s) => (s.value === null ? [] : [s.value])));
  return value === undefined ? undefined : { axis, value };
};
